import { render, staticRenderFns } from "./newsTable.vue?vue&type=template&id=73832a6a&"
import script from "./newsTable.vue?vue&type=script&lang=ts&"
export * from "./newsTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports